/**
 * Typed API error, mirroring the modeled EngineeringVectorServiceException:
 *   { message, exceptionType, resourceType }
 * plus the HTTP status code observed on the wire.
 *
 * Pure TS — no React.
 */
export class ApiError extends Error {
  /** HTTP status code of the failed response. */
  readonly status: number;
  /** Classification of the underlying exception (RETRYABLE, NON_RETRYABLE, ...). */
  readonly exceptionType?: string;
  /** Classification of the resource associated with the error. */
  readonly resourceType?: string;

  constructor(
    status: number,
    message: string,
    exceptionType?: string,
    resourceType?: string,
  ) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.exceptionType = exceptionType;
    this.resourceType = resourceType;
    // Restore prototype chain for instanceof across transpile targets.
    Object.setPrototypeOf(this, ApiError.prototype);
  }

  /** True if the backend classified this error as retryable. */
  get isRetryable(): boolean {
    return this.exceptionType === 'RETRYABLE';
  }
}
